import { Box, Icon, Typography } from "@drone-js/core";
import type { PropertySelectionItem as HmPropertySelectionItem } from "libs/codegen/homes-onbaording";
import type { PropertySelectionItem } from "libs/codegen/property-onboarding";
import { usePropertySelectionViewModelValue } from "../propertySelectionViewModelAtom";
import { CheckboxListing } from "./CheckboxListing";
import { EmptyListing } from "./EmptyListing";
import { PropertySelectionStatus } from "./constants";
import { fromUrlFirstSorter } from "./fromUrlFirstSorter";
import { usePropertiesValue } from "./propertiesAtom";
import { selectablePropertiesFilter } from "./selectablePropertiesFilter";

export const ListingSection = () => {
    const {
        automaticPropertySelectionCms: { weFoundListingsLiked, shareRoomNotImported },
    } = usePropertySelectionViewModelValue();
    const properties = usePropertiesValue();

    const propertiesOfInterest = properties.filter(selectablePropertiesFilter).sort(fromUrlFirstSorter);

    if (propertiesOfInterest.length === 0) return <EmptyListing />;

    return (
        <Box mb="32">
            {propertiesOfInterest.map((p) => (
                <CheckboxListing
                    key={`checkbox-${p.id}`}
                    id={p.id}
                    title={p.name}
                    subTitle={p.location}
                    image={(p as HmPropertySelectionItem)?.imageUrl ?? (p as PropertySelectionItem)?.image}
                    fromUrl={p.status === PropertySelectionStatus.ImportableFromRoomUrl}
                />
            ))}
            <Box display="flex" pt="16" data-element-name="choose-listing-footer-text">
                <Icon id="fill.symbol.circle-info" size="14" color="base.subtle" />
                <Typography variant="caption-default" textColor="base.subtle" ps="4">
                    {weFoundListingsLiked.replace("{0}", propertiesOfInterest.length.toString())} {shareRoomNotImported}
                </Typography>
            </Box>
        </Box>
    );
};
